import React from 'react'

function Poetry() {
  const poetry = [
    {
      id: 1,
      src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1693990092/Aman_Cover_3_i6c10a.jpg",
      speaker: "AMANDEEP KHAYAL",
      designation: "Poet-StoryTeller-Writer",
      workshop: "Poetry Workshop",
      date: "Date:6:30pm,10th September 2023",
      venue: "Venue:SAC,Nit Rourkela",
    },
    // {
    //   id: 2,
    //   src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1693989872/sangita_vqggll.jpg",
    //   speaker: "SANGITA YADUVANSHI ",
    //   designation: "Poetry Artist",
    //   workshop: "Poetry Workshop",
    //   date: "Date:9th September 2023",
    //   venue: "Venue:PPA,Nit Rourkela",
    // },
    // {
    //   id: 3,
    //   src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1693989867/vasudev_lcljsd.jpg",
    //   speaker: "VASUDEV CHAMAN ",
    //   designation: "Poetry Artist",
    //   workshop: "Poetry Workshop",
    //   date: "Date:9th September 2023",
    //   venue: "Venue:BBA,Nit Rourkela",
    // },
  ];
  return (
    <div className="poetry bg-[#999999] w-full min-h-screen relative ">
      {/* Category */}
      <div className=" pt-20 lg:pt-32 px-auto lg:pl-10 w-fit h-1/3 relative">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693936353/Group_4_1_1_lda1kz.png"
          alt="POETRY"
        ></img>
        <h1 className=" absolute text-outfit text-white text-6xl sm:text-9xl lg:text-[200px] font-black bottom-2 left-[12%] md:left-[14%] lg:left-20 tracking-widest">
          POETRY
        </h1>
      </div>

      {/* Workshop Description */}
      {poetry.map(({ id,src, speaker, designation, workshop, date, venue }) => (
        <div
          key={id}
          className="w-full h-1/3 sm:max-w-2xl lg:max-w-xl xl:max-w-3xl  flex flex-col md:flex-row items-center justify-start text-outfit mt-10  mb-2 mx-auto xl:ml-10 "
        >
          <div
            className=" w-40 h-40 md:w-64 md:h-64 xl:w-80 xl:h-80 
           bg-no-repeat bg-cover bg-center rounded-full border-8 border-[#807d7d]  hover:scale-110 duration-150 "
          >
            <img src={src} alt="music" className="w-full h-full rounded-full" />
          </div>

          <div className=" text-center md:text-left text-white h-2/3  mt-6 md:ml-10 ">
            <h className="text-3xl md:text-6xl lg:text-4xl font-extrabold ">
              {speaker}
            </h>
            <h1 className="text-2xl md:text-5xl  lg:text-3xl font-bold ">
              {designation}
            </h1>
            <br />
            <div className="text-md md:text-2xl lg:text-xl font-semibold leading-none">
              <h1>{workshop}</h1>
              <h1>{date}</h1>
              <h1>{venue}</h1>
            </div>
          </div>
        </div>
      ))}

      {/* Category Image*/}
      <div className=" sm:ml-[20%]  lg:ml-[25%] xl:absolute xl:bottom-2 xl:right-0 ">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693933261/image_3_ur8xsn.png"
          alt="ART"
          width={500}
          height={500}
        ></img>
      </div>
    </div>
  );
}

export default Poetry